import { get } from '../../../utils/get';
export var getProductFullUrl = function (item) {
    return get(item, 'product.productPageUrl.path');
};
